import { AuthService } from './../../services/auth.service';
import { GlobalService } from './../../services/global.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { map } from 'rxjs/operators';
import { FirebaseService } from 'src/app/services/firebase.service';
import { StateService } from 'src/app/services/state.service';
import { AngularFireStorage } from '@angular/fire/compat/storage';

@Component({
  selector: 'app-attachment-uploader',
  templateUrl: './attachment-uploader.component.html',
  styleUrls: ['./attachment-uploader.component.scss'],
  standalone: false
})
export class AttachmentUploaderComponent implements OnInit {
    // Progress monitoring
    uploading = false;
    uploadPercentage: any;
    downloadUrls: string[] = [];
    anzahlBilder = 0;
    anzahlFertig = 0;
    files: any[] = [];
    task: any;
    uploadprom: any;

    constructor(
        private storage: AngularFireStorage,
        public glo: GlobalService,
        public authService: AuthService,
        public stateService: StateService,
        private firebaseService: FirebaseService,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<AttachmentUploaderComponent>,
    ) {}

    ngOnInit() {
        // console.log(this.data)
    }

    startUpload(event: any) {
        this.files = Array.from(event.target.files);
        if (this.files.length < 1) {
            return;
        }
        this.anzahlBilder = this.files.length;
        this.anzahlFertig = 0;
        this.uploading = true;
        this.handleNextFile();
    }

    handleNextFile() {
        if (!this.files[this.anzahlFertig]) {
            return;
        }
        let file = this.files[this.anzahlFertig];
        // Client-side validation example
        if (file.type.split('/')[0] !== 'image' && file.type.split('/')[0] !== 'pdf') {
            console.error('unsupported file type :( ');
            this.glo.alert('Bitte nur Bilder oder PDFs auswählen!');
            return;
        }
        this.uploadprom = this.uploadSingleFile(file).then(async (imagePath) => {
            if (imagePath) {
                const dURL = await this.storage.ref(imagePath).getDownloadURL().toPromise();
                // console.log(dURL)
                this.downloadUrls.push(dURL);
            }

            file = null;
            this.task = null;
            if (this.files) {
                this.files[this.anzahlFertig] = null;
            }
            this.anzahlFertig++;
            this.uploadPercentage = null;
            if (this.files && this.files[this.anzahlFertig]) {
                this.handleNextFile();
            } else {
                this.uploading = false;
            }
        });
    }

    async uploadSingleFile(file: File) {
        let dateiname = file.name;
        const dateinamesplit = dateiname.split('.');
        const endung = dateinamesplit[dateiname.split('.').length - 1];
        if (!endung) {
            return;
        }
        dateinamesplit.pop();
        dateiname = dateinamesplit.join('.');

        dateiname = dateiname + '.' + endung;

        const newkey = this.firebaseService.createPushId();
        const path = `userUploads/${this.authService.getUid()}/${newkey}/${dateiname}`;

        // console.log(path);
        this.task = this.storage.upload(path, file, {});
        this.uploadPercentage = this.task.percentageChanges().pipe(map((per) => this.kround(per)));
        await this.task;
        return path;
    }

    kround(n: any) {
        if (!n) {
            return 0;
        }
        const multiplicator = Math.pow(10, 2);
        n = parseFloat((n * multiplicator).toFixed(11));
        const test = Math.round(n) / multiplicator;
        return +test.toFixed(2);
    }

    async close() {
        if (this.uploading) {
            this.glo
                .confirm('Laufende Uploads werden beim Beenden abgebrochen. Trotzdem Schliessen?')
                .subscribe((result) => {
                    if (result) {
                        this.dialogRef.close();
                    }
                });
        } else {
            this.dialogRef.close(this.downloadUrls);
        }
    }

    ngOnDestroy(): void {
        this.files = [];
    }
}
